// TODO - Type 'any' needs to be fixed.
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  changeSelectedMenuItemId,
  closeNavigationDrawer,
} from "../../../ts/features/navigation-drawer/navigation-drawer-slice";
import PageLayout from "../../design/wilya-page-layout";
import NavDrawer from "../drawer/ui";
import WorkerActivityDashboard from "./worker-activity-dashboard";

const WorkerActivity = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    // To select admin config menu item
    dispatch(changeSelectedMenuItemId(21));
    dispatch(closeNavigationDrawer());
  }, [dispatch]);
	return (
		<Box sx={{ display: "flex", backgroundColor: "#F5F5F5" }}>
			<CssBaseline />
			<NavDrawer keepSettingOpen={false} keepReportOpen={true} />
			<Box sx={{ flexGrow: 1, overflow: "auto" }}>
				<PageLayout>
					<WorkerActivityDashboard />
				</PageLayout>
			</Box>
		</Box>
	);
};

export default WorkerActivity;
